import { render } from "./BadgeEditor.vue?vue&type=template&id=dae78e42&scoped=true"
import script from "./BadgeEditor.vue?vue&type=script&lang=js"
export * from "./BadgeEditor.vue?vue&type=script&lang=js"

import "./BadgeEditor.vue?vue&type=style&index=0&id=dae78e42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dae78e42"]])

export default __exports__